export const PAGE_PATH = '/faq';
